export const validateScorecardData = (data) => {
  // Check if new logic is being used
  if (!data.new_logic) {
    console.warn('Using legacy scorecard system');
    return false;
  }
  
  // Validate required fields
  const requiredFields = [
    'session_id', 'total_apps', 'summary_by_scorecard', 
    'overall_summary', 'apps_needing_review'
  ];
  
  for (const field of requiredFields) {
    if (!(field in data)) {
      console.error(`Missing required field: ${field}`);
      return false;
    }
  }
  
  // Validate scorecard structure
  for (let i = 1; i <= 4; i++) {
    const scorecard = data.summary_by_scorecard[`scorecard_${i}`];
    if (!scorecard) {
      console.error(`Missing scorecard_${i} data`);
      return false;
    }
    
    if (i <= 2) {
      // Validate bucket structure for SC1 & SC2
      const requiredBuckets = ['bucket_1_3', 'bucket_4_6', 'bucket_7_10', 'errors', 'total'];
      for (const bucket of requiredBuckets) {
        if (typeof scorecard[bucket] !== 'number') {
          console.error(`Invalid ${bucket} in scorecard_${i}`);
          return false;
        }
      }
    } else {
      // Validate match structure for SC3 & SC4
      const requiredFields = ['match', 'no_match', 'errors', 'total'];
      for (const field of requiredFields) {
        if (typeof scorecard[field] !== 'number') {
          console.error(`Invalid ${field} in scorecard_${i}`);
          return false;
        }
      }
    }
  }
  
  return true;
};

export const isLegacyScorecardData = (data) => {
  // Check if data uses old pass/refer/fail structure
  if (!data.summary_by_scorecard) return true;
  
  const firstScorecard = Object.values(data.summary_by_scorecard)[0];
  if (!firstScorecard) return true;
  
  // Old format has pass/refer/fail fields, new format has buckets or match/no_match
  return 'pass' in firstScorecard && 'refer' in firstScorecard && 'fail' in firstScorecard;
};